module.exports = __webpack_public_path__ + "static/media/check.b2cfb855.png";